import uniqid from "uniqid";

export const TRACE_HEADER = "X-Trace-Id";
export const CONSULTATION_HEADER = "X-Consultation-Id";
export const USER_HEADER = "X-Current-User";
export const CLIENT_IP_HEADER = "X-Client-Ip";

const STORAGE_KEY = "reissues_traceability";

const readState = () => {
    try {
        const rawState = sessionStorage.getItem(STORAGE_KEY);
        return rawState ? JSON.parse(rawState) : {};
    } catch {
        return {};
    }
};

const writeState = (state) => {
    try {
        sessionStorage.setItem(STORAGE_KEY, JSON.stringify(state));
    } catch {
        return null;
    }
};

const generateId = (prefix) => `${prefix}_${uniqid()}`;

const getHeader = (headers, headerName) => {
    if (!headers) {
        return null;
    }

    const normalizedHeaderName = headerName.toLowerCase();
    const key = Object.keys(headers).find(item => item.toLowerCase() === normalizedHeaderName);
    return key ? headers[key] : null;
};

export const getQueryParam = (search, key) => {
    if (!search) {
        return null;
    }

    const query = search.charAt(0) === "?" ? search.substring(1) : search;
    const params = query.split("&");

    for (let i = 0; i < params.length; i++) {
        const pair = params[i].split("=");
        if (decodeURIComponent(pair[0]) === key) {
            return decodeURIComponent(pair[1] || "");
        }
    }

    return null;
};

export const initializeTrace = (traceId, userInfo) => {
    const state = readState();
    const nextState = {
        ...state,
        traceId: traceId || state.traceId || generateId("trace"),
        userInfo: userInfo || state.userInfo || {}
    };

    writeState(nextState);
    return nextState.traceId;
};

export const createConsultationId = () => {
    const state = readState();
    const consultationId = generateId("consultation");

    writeState({
        ...state,
        consultationId
    });

    return consultationId;
};

export const getTraceState = () => readState();

export const getTraceHeaders = (consultationId) => {
    const state = readState();
    const traceId = state.traceId || initializeTrace();
    const activeConsultationId = consultationId || state.consultationId;
    const currentUser = state.userInfo && (state.userInfo.currentUser || state.userInfo.userId || state.userInfo.userName);
    const headers = {
        [TRACE_HEADER]: traceId
    };

    if (activeConsultationId) {
        headers[CONSULTATION_HEADER] = activeConsultationId;
    }

    if (currentUser) {
        headers[USER_HEADER] = currentUser;
    }

    if (state.clientIp) {
        headers[CLIENT_IP_HEADER] = state.clientIp;
    }

    return headers;
};

export const syncTraceFromResponse = (response) => {
    const traceId = getHeader(response && response.headers, TRACE_HEADER);
    const consultationId = getHeader(response && response.headers, CONSULTATION_HEADER);
    const clientIp = getHeader(response && response.headers, CLIENT_IP_HEADER);

    if (!traceId && !consultationId && !clientIp) {
        return;
    }

    const state = readState();
    writeState({
        ...state,
        traceId: traceId || state.traceId,
        consultationId: consultationId || state.consultationId,
        clientIp: clientIp || state.clientIp
    });
};

export const buildUserInfo = (params = {}, travelItineraryRS = {}) => ({
    currentUser: params.currentUser,
    userId: params.currentUser,
    userName: params.currentUser,
    accountId: params.accountId || travelItineraryRS.accountId,
    recordLocator: params.pnr || travelItineraryRS.pnr,
    pseudoCityCode: travelItineraryRS.ticketing && travelItineraryRS.ticketing[0]
        ? travelItineraryRS.ticketing[0].pseudoCityCode
        : null,
    gds: params.gds || (
        travelItineraryRS.ticketing && travelItineraryRS.ticketing[0] && travelItineraryRS.ticketing[0].pricingSystem
            ? travelItineraryRS.ticketing[0].pricingSystem.code
            : null
    )
});
